export default function InputThreshold(props) {
    const {name, value, isEditable} = props;
    
    const onKeyUp = (e) => {
        const value = e.target.value.replace(/\s/g, '');
        if (isNaN(Number(value))) {
            e.target.value = value.replace(/[^0-9]/g, '');
        } else {
            e.target.value = value;
        }
    };
    return (
        <input
            className="tmd__input"
            type='text'
            name={name}
            defaultValue={value}
            disabled={!isEditable}
            onKeyUpCapture={onKeyUp}
        />
    );
}